/**
 * Aturan format nomor identitas per jenis.
 *
 * Paspor memuat HURUF (Indonesia: 1 huruf + 7 angka; banyak negara lain seluruhnya
 * alfanumerik), jadi "angka saja" hanya sah untuk KTP/NIK. Satu tempat karena DUA permukaan
 * memakainya dan dua-duanya menulis kolom yang sama: data tamu checkout
 * (`GuestDataSection`) dan edit profil (`Profile.vue`).
 */

const DIGITS_ONLY = /^\d+$/;
const ALPHANUMERIC = /^[A-Za-z0-9]+$/;

export function isPassportIdentity(identityType) {
   return String(identityType ?? "").trim().toUpperCase() === "PASSPORT";
}

export function isValidIdentityNumber(value, identityType) {
   const trimmed = String(value ?? "").trim();
   return (isPassportIdentity(identityType) ? ALPHANUMERIC : DIGITS_ONLY).test(trimmed);
}
